export const testCurrentDomain = (domainsToTest: string[]) => {
  const currentDomain = window.location.origin;
  return domainsToTest.some((item) => currentDomain.includes(item));
};
